// extracted by mini-css-extract-plugin
module.exports = {"actionsContainer":"styles_actionsContainer__xT7If","edit":"styles_edit__1sx-3","editPadron":"styles_editPadron__1Uwe9","separator":"styles_separator__1PQ3X"};